<p-calendar mojoUseUtc
            [(ngModel)]="model.field1" placeholder="From..." dateFormat="dd/mm/yy"
            [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2100"
            (onSelect)="onValueChange()" (onInput)="onValueChange()" appendTo="body"></p-calendar>

<p-calendar mojoUseUtc
            [(ngModel)]="model.field2" placeholder="To..." dateFormat="dd/mm/yy"
            [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2100"
            (onSelect)="onValueChange()" (onInput)="onValueChange()" appendTo="body"></p-calendar>

